import styled from "styled-components";

export const BackDiv = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(49, 49, 49, 0.8);
  z-index: 999;
`;

export const Overlay = styled.div`
  display: flex;
  flex-direction: column;
  transition: 0.64s ease-in-out;
  max-height: 90vh;
`;

export const ModalContent = styled.div`
  display: flex;
  position: fixed;
  height: 75%;
  width: 55%;
  max-height: 90%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 50px 1px #63c0ae;
  background: #aeb6bf;
  padding: 14px 20px;
  border-radius: 7px 7px 7px 7px;
  @media only screen and (max-width: 760px) {
    width: 95%;
    height: 90%;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  padding: 1rem;
  text-align: center;
  overflow: hidden;
  word-wrap: break-word;
  max-height: 85%;
  h1 {
    font-size: 2rem;
    font-weight: 600;
    text-transform: uppercase;
    color: #0a0a0a;
    text-decoration: overline;

    @media only screen and (max-width: 760px) {
      font-size: 30px;
    }
  }
  p {
    font-size: 18px;
    line-height: 1.5;

    @media only screen and (max-width: 760px) {
      font-size: 14px;
    }
  }
`;

export const Imgcontqiner = styled.img`
  margin-top: 1rem;
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  width: 60%;
  height: 90%;
  border-radius: 7px 7px 7px 7px;
  @media only screen and (max-width: 760px) {
    max-width: 50%;
    max-height: 80%;
  }
`;

export const Closebtn = styled.span`
  margin-top: 6%;
  margin-left: 77%;
  background-color: #63c0ae;
  width: 40px;
  padding: 8px 6px;
  text-align: center;
  cursor: pointer;
  border-radius: 16px;
  font-size: large;
  font-weight: 1000;
  z-index: 1;

  @media only screen and (max-width: 760px) {
    margin-top: 6%;
    margin-left: 90%;
  }
`;

export const BuyButton = styled.div`
  position: absolute;

  top: auto;
  bottom: 320px;
  left: 40%;
  display: flex;
  button {
    display: flex !important;
    opacity: 1 !important;
  }
  @media only screen and (max-width: 760px) {
    top: 58%;
    bottom: 90px;
    left: 32%;
  }
`;
